module.exports = __webpack_public_path__ + "static/bigpeach-b66188be50e64fd08a7a4224ecdffdf3.jpg";